<script>
    export let album;
    export let title;
    const url = `https://api.imgur.com/3/album/${album}/images`;
    let images = [];
    let currentImage = null;

    fetch(url, {headers: {Authorization: 'Client-ID 7bc5085c689350f'}})
            .then(response => response.json())
            .then(data => images = data.data);

    function showPhoto(image) {
        console.log(image);
        currentImage = image;
    }

    function closeDetail() {
        currentImage = null;
    }

    function checkForClose(event) {
        if (event.target.classList.contains('detail')) {
            currentImage = null;
        }
    }

    function nextImage() {
        let index = images.indexOf(currentImage);
        index++;
        if (index >= images.length) {
            index = 0;
        }
        currentImage = images[index];
    }

    function prevImage() {
        let index = images.indexOf(currentImage);
        index--;
        if (index < 0) {
            index = images.length - 1;
        }
        currentImage = images[index];
    }
</script>
<style>
    .photo {
        margin-right: 8px;
        margin-bottom: 8px;
        cursor: pointer;
        overflow: hidden;
        width: 146px;
        height: 146px;
        display: inline-block;
    }

    .photo img {
        transition: transform .5s ease;
        width: 146px;
        height: 146px;
        object-fit: cover;
    }

    .photo:hover img {
        transform: scale(1.1);
    }

    .photos .photo:nth-child(even) {
        margin-right: 0;
    }

    .photos {
    }

    .detail {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.6);
    }

    .detail .img {
        position: relative;
        margin: 32px;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    }

    .detail img {
        max-width: calc(100vw - 64px);
        max-height: calc(100vh - 64px);
    }

    .close-btn {
        border-bottom-left-radius: 8px;
        top: 0;
        right: 0;
    }

    .detail-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.8);
        font-size: 1.2em;
        padding: 4px 8px;
        border: 0;
        color: #fff;
        position: absolute;
        cursor: pointer;
    }

    .detail-btn:focus {
        outline: none;
    }
    .detail-btn svg {
        width: 15px;
    }

    .next-btn {
        top: calc(50% - 24px);
        right: 0;
        height: 48px;
        border-bottom-left-radius: 100%;
        border-top-left-radius: 100%;
        padding: 16px;
        padding-right: 4px;
    }

    .prev-btn {
        top: calc(50% - 24px);
        height: 48px;
        padding: 16px;
        padding-left: 4px;
        left: 0;
        border-bottom-right-radius: 100%;
        border-top-right-radius: 100%;
    }
    .detail-title {
        background: white;
        padding: 8px;
    }
    .detail-text {
        background: white;
        padding: 8px;
    }
</style>


<article class="card">
    <h2 class="title">{title}</h2>
    <div class="description photos">
        {#each images as image}
            <div class="photo" on:click={() => showPhoto(image)}>
                <img alt="{image.description}" src="{image.link}"/>
            </div>
        {/each}
    </div>

    {#if currentImage }
        <div class="detail" on:click={checkForClose}>
            <div class="img">
                <button class="close-btn detail-btn" on:click={closeDetail}>Schliessen</button>
                <img alt="{currentImage.description}" src="{currentImage.link}"/>
                {#if currentImage.title }
                    <div class="detail-title">{currentImage.title || ''}</div>
                {/if}
                {#if currentImage.description }
                    <div class="detail-text">{currentImage.description || ''}</div>
                {/if}
                <button class="next-btn detail-btn " on:click={nextImage}>
                    <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path fill="#fff" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"></path></svg>
                </button>
                <button class="prev-btn detail-btn" on:click={prevImage}>
                    <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 192 512">
                        <path fill="#fff"
                              d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z">
                        </path>
                    </svg>
                </button>
            </div>
        </div>
    {/if}
</article>
